import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col justify-center items-center h-full gap-4 py-5 px-2"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "text-xl font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.data)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.image)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: require(`../../assets/images/empty/${_ctx.image}`),
              class: _normalizeClass(`w-full ${_ctx.imgSize}`),
              alt: "img-empty",
              loading: "lazy"
            }, null, 10, _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.title), 1),
        _createElementVNode("p", {
          class: _normalizeClass(`text-gray-500 text-center w-100 ${_ctx.msgSize}`)
        }, _toDisplayString(_ctx.label), 3)
      ]))
    : _createCommentVNode("", true)
}